import * as Yup from "yup";

export const schemaAddAdminAccount = Yup.object().shape({
  firstName: Yup.string()
    .min(3, "First name field must be at least 3 characters long")
    .required("First name is a required field"),
  lastName: Yup.string()
    .min(3, "Last name field must be at least 3 characters long")
    .required("Last name is a required field"),
  email: Yup.string()
    .email("Field email is wrong")
    .required("Email is a required field"),
});
